/*
  Strony prawne: drobna normalizacja markupu z edytora (patrz legal-pages.css).
  Nie zmienia treści — tylko nadaje klasy prezentacyjne.
*/
(function () {
  var norm = function (t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
  var roots = document.querySelectorAll('.legal-page__body, .shopify-policy__body .rte');
  Array.prototype.forEach.call(roots, function (root) {
    // Wiersz, którego cała treść jest pogrubiona, to nagłówek sekcji.
    Array.prototype.forEach.call(root.querySelectorAll('p, div'), function (el) {
      if (el.children.length !== 1) return;
      var strong = el.children[0];
      if (strong.tagName !== 'STRONG' || strong.querySelector('a')) return;
      var text = norm(strong.textContent);
      if (text && text.length < 140 && norm(el.textContent) === text) el.classList.add('legal-heading');
    });
    // Pierwszy nagłówek powtarzający tytuł strony.
    var scope = root.closest('.legal-page') || root.closest('.shopify-policy__container') || document;
    var title = scope.querySelector('.legal-page__title, .shopify-policy__title h1');
    var first = root.firstElementChild;
    if (title && first && /^H[1-4]$/.test(first.tagName)) {
      var t = norm(title.textContent), f = norm(first.textContent);
      if (t && f.indexOf(t) === 0) first.classList.add('legal-dup-title');
    }
  });
})();
